import { Space, Spin, Title } from "@app/ui";
import { useCan } from "../auth/useCan.js";
import { CertificationsCard } from "../facilities/CertificationsCard.js";
import { FacilitiesCard } from "../facilities/FacilitiesCard.js";
import { PartnersCard } from "../facilities/PartnersCard.js";
import { useT } from "../i18n.js";
import { NoOrgState } from "../orgs/NoOrgState.js";
import { useOrgs } from "../orgs/OrgContext.js";

/**
 * Org master data used across products: production sites, certificates and
 * circularity partners. Each card loads and edits its own list.
 */
export function FacilitiesPage() {
  const t = useT();
  const can = useCan();
  const { org, loading: orgsLoading } = useOrgs();
  const canWrite = can("product:write");

  if (orgsLoading) return <Spin />;
  if (!org) return <NoOrgState />;

  return (
    <Space direction="vertical" size="lg" style={{ width: "100%" }}>
      <Title level={2}>{t("facilities.title")}</Title>
      <FacilitiesCard orgId={org.id} canWrite={canWrite} />
      <CertificationsCard orgId={org.id} canWrite={canWrite} />
      <PartnersCard orgId={org.id} canWrite={canWrite} />
    </Space>
  );
}
